import { apiClient } from '@/services/config.js'


export default {
    fetchWeeklySales() {
        return apiClient.get("/api/weekly-sales")
    },
    

}